module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "dynamic-product-list"
  }, [_c('div', {
    staticClass: "btm-line"
  }), _vm._v(" "), _vm._l((_vm.products), function(item, index) {
    return _c('dynamic-product', {
      key: index,
      attrs: {
        "data": item,
        "index": index,
        "productCondition": _vm.listCondition,
        "miniEnv": _vm.miniEnv,
        "productImageHeight": _vm.productImageHeight,
        "hideInfoPadding": _vm.checkInfoPadding(index)
      },
      on: {
        "product-simple": _vm.productSimpleJump
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94356d42"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/dynamic-product-list/index.vue
// module id = 661
// module chunks = 1 14